import { registerAction } from '../../Action'

const REMOVE_MESSAGE = 'REMOVE_MESSAGE'

const reducer = (state = {}, action) => {
  const messages = { ...state.jsonApiEntities.message }
  delete messages[action.payload]
  return {
    ...state,
    jsonApiEntities: { ...state.jsonApiEntities, message: messages },
  }
}

const removeMessage = registerAction(REMOVE_MESSAGE, { reducer })

export default removeMessage
